import {
  GET_ALL_PROCUREMENT_LIST_REQUEST,
  GET_ALL_PROCUREMENT_LIST_SUCCESS,
  GET_ALL_PROCUREMENT_LIST_FAILURE,
  POST_PROCUREMENT_REQUEST,
  POST_PROCUREMENT_SUCCESS,
  POST_PROCUREMENT_FAILURE,
  PUT_PROCUREMENT_REQUEST,
  PUT_PROCUREMENT_SUCCESS,
  PUT_PROCUREMENT_FAILURE,
  DELETE_PROCUREMENT_REQUEST,
  DELETE_PROCUREMENT_SUCCESS,
  DELETE_PROCUREMENT_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  loading: false,
  error: null,
  procurementList: {},
  addProcurement: {},
  deleteList: {},
  updateProcurement: {},
  procumentSuccess: false
};

export const procurementReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_PROCUREMENT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_PROCUREMENT_LIST_SUCCESS:
      return {
        ...state,
        procurementList: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_PROCUREMENT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case POST_PROCUREMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        procumentSuccess: false,
      };
    case POST_PROCUREMENT_SUCCESS:
      return {
        ...state,
        addProcurement: action.payload,
        loading: false,
        error: null,
        procumentSuccess: true,
      };
    case POST_PROCUREMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        procumentSuccess: false,
      };
    case PUT_PROCUREMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PUT_PROCUREMENT_SUCCESS:
      return {
        ...state,
        updateProcurement: action.payload,
        loading: false,
        error: null,
      };
    case PUT_PROCUREMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_PROCUREMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_PROCUREMENT_SUCCESS:
      return {
        ...state,
        deleteProcurement: action.payload,
        loading: false,
        error: null,
      };
    case DELETE_PROCUREMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
